import { BsBuildingExclamation, BsCalendar2Week, BsCheckCircle, BsPersonVcard, BsRecord2, BsReverseLayoutTextWindowReverse, BsXCircle } from "react-icons/bs";
import Loading from "../../../Panel/Common/Components/Loading";

import { FiUsers, FiUser } from "react-icons/fi";
import { HiOutlineDevicePhoneMobile } from "react-icons/hi2";
import { AiOutlineBarcode, AiOutlineFieldTime } from "react-icons/ai";
import { Day, GenderRender, ToDateJalali, sepMony } from "../../../Panel/Common/Function";
import { useOrderDetails } from "../../../Panel/Common/Components/OrderDetails/Hooks";
import CustomModal from "../../../Panel/Common/Components/Modal/CustomModal";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Get } from "../../../Request";
import { toast } from "react-hot-toast";
import { MdPayments } from "react-icons/md";
import { IoPricetagOutline } from "react-icons/io5";

const DetailPage = ({ data, loading, appModal, setExpired, setUpdateAll, updateAll, refundOrder, isAbsent, locRole }) => {

    const { user } = useSelector((state) => state);
    const [modal, setModal] = useState(false);
    let uType;
    const [refundList, setRefundList] = useState();

    if (locRole == "manager" || user.role == "manager") {
        uType = "manager"
    }
    if (locRole == "user" || user.role == "user") {
        uType = "user"
    }

    const getRefund = () => {
        let item_id;
        if (data?.product?.contract_product) {
            item_id = data?.product?.contract_product[0]?.item_id;
        }
        else if (data?.times) {
            item_id = data?.times[0]?.item_id;
        }
        else if (data?.product?.reserve_product) {
            item_id = data?.product?.reserve_product[0]?.item_id;
        }

        Get({ url: "/refundsetting/getall", data: { item_id: item_id } }).then(data => {

            setRefundList(data)
        });

    };

    let showRefund = true;

    if (data?.order?.model_order == "contractual_reservation" || data?.order?.model_order == "contractual_reservation_installments") {
        showRefund = false
    }


    const Renderststus = type => {
        switch (type) {
            case "peyed":
                return { name: "پرداخت شده", status: 1 };
            case "payerror":
                return { name: "عدم پرداخت", status: 0 };
            case "used":
                return { name: "منقضی شده", status: 0 };
            case "waittopay":
                return { name: "پرداخت رها شده", status: 0 };
            case "refund":
                return { name: "استرداد شده", status: 0 }
            case "canceled":
                return { tenamext: "لغو شده", status: 0 }
            default:
                return { name: "---", status: 0 }
        }
    };
    const Rendertypeorder = type => {
        switch (type) {
            case "reserve":
                return "رزرواسیون";
            case "walletsharge":
                return "شارژ کیف پول";
            case "joinclass":
                return "ثبت نام در کلاس";
            case "contractual_reservation":
                return "رزرو قراردادی";
            case "contractual_reservation_installments":
                return " رزرو قراردادی باز پرداخت بازه ای";
        }
    };
    const RendertypePay = type => {
        switch (type) {
            case "gateway":
                return "پرداخت آنلاین";
            case "wallet":
                return "پرداخت از کیف پول";
            case "others":
                return "پرداخت در محل";
        }
    };

    if (loading) {
        return (<Loading col={12} height={"40px"} count={4} />)
    }

    return (
        <div style={Renderststus(data.order.status).status
            ? { ...styles.detailPage, ...styles.successPage }
            : { ...styles.detailPage, ...styles.errorPage }}>

            <div className="my-3 text-white text-center ">
                {Renderststus(data.order.status).status
                    ? <BsCheckCircle size={"50px"} />
                    : <BsXCircle size={"50px"} />
                }
                <p className="mt-2 nfs-16 text-center">
                    {Renderststus(data.order.status).name}
                </p>
            </div>

            <div className="px-3">
                <div className="bg-white p-3" style={{ borderRadius: "10px" }}>
                    <div className="row">

                        {Renderststus(data.order.status).status == 1 && (
                            data?.product?.reserve_product?.length > 1 &&
                            <div className="col-12 d-flex justify-content-center mb-3">
                                <button className="btn btnMain" style={{ width: "100px" }}
                                    onClick={e => {
                                        if (uType == "user") {
                                            setModal({
                                                visible: true, oId: data.order.order_id,
                                                header: "بلیت استرداد شود ؟", step: "refund"
                                            });
                                            getRefund();
                                        }
                                        else {
                                            appModal()
                                        }
                                    }}>

                                    {uType == "user" ? "استرداد" : isAbsent ? "ثبت حضور" : "منقضی کردن"}

                                </button>
                            </div>
                        )}

                        {uType == "user" &&
                            <>
                                {data?.product &&
                                    <DetailBox col="col-12" title={"اطلاعات مجموعه"}
                                        data={[
                                            { title: "نام مجموعه", icon: <BsBuildingExclamation size={20} />, value: data?.product?.reserve_details?.item_name || data?.product?.item_name },
                                        ]} />
                                }

                                <DetailBox col="col-12" title={"مشخصات سفارش"}
                                    data={[
                                        { col: "col-6", title: "کد پیگیری سفارش", icon: <BsReverseLayoutTextWindowReverse size={20} />, value: data?.order?.trackingcodeorder },
                                        { col: "col-6", title: "نوع سفارش", icon: <BsReverseLayoutTextWindowReverse size={20} />, value: Rendertypeorder(data?.order?.model_order) },
                                        { col: "col-6", title: "مجموع مبلغ", icon: <BsReverseLayoutTextWindowReverse size={20} />, value: sepMony(data?.order?.total_price) + " تومان" },
                                        { col: "col-6", title: "مبلغ پرداخت شده", icon: <BsReverseLayoutTextWindowReverse size={20} />, value: sepMony(data?.order?.growth_price) + " تومان" },
                                        { col: "col-6", title: "میزان تخفیف", icon: <BsReverseLayoutTextWindowReverse size={20} />, value: sepMony(data?.order?.discount) + " تومان" },
                                    ]} />

                                <DetailBox col="col-12" title={"مشخصات پرداخت"}
                                    data={[
                                        { col: "col-6", title: "نوع پرداخت ", icon: <MdPayments size={20} />, value: RendertypePay(data?.peyment?.type_payment) },
                                        { col: "col-6", title: "شماره پیگری پرداخت", icon: <MdPayments size={20} />, value: data?.peyment?.trackingcode },
                                        { col: "col-6", title: "شماره تراکنش", icon: <MdPayments size={20} />, value: data?.peyment?.transid },
                                        { col: "col-6", title: "مبلغ ", icon: <MdPayments size={20} />, value: sepMony(data?.peyment?.total_price) + " تومان" },
                                    ]} />
                            </>
                        }

                        {uType == "manager" &&
                            <>
                                <DetailBox col="col-6" title={"اطلاعات کاربر"}
                                    data={[
                                        { title: "اطلاعات کاربر", icon: <FiUser size={20} />, value: data?.user_buyer?.fullname },
                                        { title: "شماره موبایل", icon: <HiOutlineDevicePhoneMobile size={20} />, value: data?.user_buyer?.mobile },
                                        { title: "کد ملی", icon: <BsPersonVcard size={20} />, value: data?.user_buyer?.national_code }
                                    ]} />

                                <DetailBox col="col-6" title={"اطلاعات رزرو"}
                                    data={[
                                        { title: "تعداد همراه", icon: <FiUsers size={20} />, value: "---" },
                                        { title: "کد پیگیری", icon: <AiOutlineBarcode size={20} />, value: data?.peyment?.trackingcode ? data?.peyment?.trackingcode : " - " },
                                        { title: "قیمت", icon: <IoPricetagOutline size={20} />, value: data?.peyment?.total_price ? `${sepMony(data?.peyment?.total_price)} تومان` : " - " },
                                    ]} />
                            </>
                        }

                        {data?.product && <div className="col-12">

                            <p className="nfs-12 mb-2">مشخصات رزرو</p>

                            {!showRefund && <p className="nfs-10 fw300 nfc-E42A3F mb-3">رزرو های قرار دادی قابل استرداد نمی‌باشد !</p>}

                            {data?.product?.contract_product?.length > 1 &&
                                <div className="row">
                                    {data?.product?.contract_product.map((item, key) => (
                                        <ItemBox getRefund={e => getRefund()} showRefund={showRefund} key={key} item={item} setModal={setModal} uType={uType} isAbsent={isAbsent} />
                                    ))}
                                </div>
                            }
                            {data?.times?.length > 1 &&
                                <div className="row">
                                    {data?.times.map((item, key) => (
                                        <ItemBox getRefund={e => getRefund()} showRefund={showRefund} key={key} item={item} setModal={setModal} uType={uType} isAbsent={isAbsent} />
                                    ))}
                                </div>
                            }
                            {data?.product?.reserve_product?.length > 1 &&
                                <div className="row">
                                    {data?.product?.reserve_product.map((item, key) => (
                                        <ItemBox getRefund={e => getRefund()} showRefund={showRefund} key={key} item={item} setModal={setModal} uType={uType} isAbsent={isAbsent} />
                                    ))}
                                </div>
                            }

                            {data?.product?.reserve_product?.length == 1 &&
                                <>
                                    {data?.product?.reserve_time?.dayname &&
                                        <div className="d-flex mb-2" >
                                            <div style={styles.orderItemIcon}>
                                                <BsCalendar2Week size={20} />
                                            </div>
                                            <div>
                                                <p style={styles.titr}>روز</p>
                                                <p style={styles.txtValue}>
                                                    {Day(data?.product?.reserve_time?.dayname)}
                                                </p>
                                            </div>
                                        </div>
                                    }
                                    {data?.product?.reserve_time?.date &&
                                        <div className="d-flex mb-2" >
                                            <div style={styles.orderItemIcon}>
                                                <BsCalendar2Week size={20} />
                                            </div>
                                            <div>
                                                <p style={styles.titr}>تاریخ</p>
                                                <p style={styles.txtValue}>
                                                    {ToDateJalali(data?.product?.reserve_time?.date)}
                                                </p>
                                            </div>
                                        </div>
                                    }
                                    {data?.product?.reserve_time?.start &&
                                        <div className="d-flex mb-3" >
                                            <div style={styles.orderItemIcon}>
                                                <AiOutlineFieldTime size={20} />
                                            </div>
                                            <div>
                                                <p style={styles.titr}>زمان</p>
                                                <p style={styles.txtValue}>
                                                    {data?.product?.reserve_time?.start}
                                                    <span className="mx-1">تا </span>
                                                    {data?.product?.reserve_time?.end}
                                                </p>
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                        }

                        {data?.product?.reserve_product?.length == 1 && (
                            +Renderststus(data.order.status).status
                                ? <div className="col-12 d-flex justify-content-center mt-4">
                                    <button className="btn btn-primary" onClick={() => {
                                        if (uType == "manager") {
                                            appModal()
                                        }
                                        else {
                                            setModal({
                                                visible: true, oId: data.order.order_id,
                                                header: "بلیت استرداد شود ؟", step: "refund"
                                            });
                                            getRefund();
                                        }
                                    }} >
                                        {uType == "manager"
                                            ? isAbsent ? "ثبت حضور" : "منقضی کردن بلیت"
                                            : "استرداد بلیت"
                                        }

                                    </button>
                                </div>
                                : null
                        )}

                    </div>
                </div>
            </div>

            <CustomModal
                size={"md"}
                show={modal.visible}
                header={modal.header}
                handleClose={() => {
                    setModal({ visible: false });
                }} >
                <div className="d-flex flex-wrap">
                    {refundList && refundList.length > 0 &&
                        (<div className="col-12 p-0 nfs-12 mb-3">
                            <p className="mr-3 text-danger mb-2">
                                استرداد قبل از آخرین زمان ثبت شده امکان پذیر است
                            </p>
                            {refundList.map(item => (
                                <div key={item.id} className="mb-2 mr-3">
                                    <BsRecord2 className="ml-2" />
                                    میزان کسری
                                    <span className="font-weight-bold">
                                        {" " + (item.remaining_time) + " "}
                                    </span>
                                    ساعت قبل از شروع  :
                                    <span className="font-weight-bold">
                                        {" " + (item.percentage) + " "}
                                        %
                                    </span>
                                </div>
                            ))}
                        </div>)

                    }

                    <button className="btn btn-primary flex-fill ml-1"
                        onClick={() => {
                            if (modal.step == "singleEX") {
                                setExpired({
                                    action: "specific",
                                    order_id: modal.oId,
                                    reseves: modal.rId
                                }).then(re => {
                                    setModal({ visible: false });
                                    setUpdateAll(updateAll + 1);
                                })
                            }
                            else if (modal.step == "refund") {
                                refundOrder(modal.oId).then(re => {
                                    setModal({ visible: false });
                                    setUpdateAll(updateAll + 1);
                                })
                            }
                            else if (modal.step == "singleRefund") {
                                Get({ url: "/reserve/refund", data: { reserve_id: modal.rId }, addRes: true }).then(data => {
                                    if (data.status == "Success") {
                                        toast.success("بلیت شما با موفقیت استرداد شد")
                                    }
                                }).then(re => {
                                    setModal({ visible: false });
                                    setUpdateAll(updateAll + 1);
                                })
                            }
                        }
                        } >
                        بله
                    </button>

                    <button className="btn btn-secondary flex-fill mr-1 nfs-10"
                        onClick={() => {
                            setModal({ visible: false });
                        }}
                    >
                        خیر
                    </button>
                </div>

            </CustomModal>

        </div >
    );
}
const DetailBox = ({ col, title, data }) => {
    return (
        <div className={"mb-4 " + col}>
            <p className="nfs-12 mb-2">{title}</p>
            <div className="row">
                {data.map((item, key) => (
                    item.value &&
                    <div key={key} className={"d-flex mb-3 " + (item.col ? item.col : "col-12")} >
                        <div style={styles.orderItemIcon}>
                            {item.icon}
                        </div>
                        <div>
                            <p style={styles.titr}>{item.title}</p>
                            <p style={styles.txtValue}>
                                {item.value}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

const ItemBox = ({ showRefund, item, setModal, uType, isAbsent, getRefund }) => {

    return (
        <div className="col-4 mb-2">
            <div className="rounded py-3 px-1" style={{ border: "1px solid #939393" }}>

                {item?.type &&
                    <>
                        <p className="mb-2 text-center" style={styles.txtValue}>
                            {(item?.type == "child" ? "خردسال" : "بزرگسال")}
                        </p>
                    </>
                }

                {item.reserve_time?.date &&
                    <>
                        <p style={styles.titr}>تاریخ</p>


                        {item.reserve_time?.dayname &&
                            <p style={styles.txtValue}>
                                {Day(item.reserve_time?.dayname)}
                            </p>
                        }

                        <p className="mb-2" style={styles.txtValue}>
                            {ToDateJalali(item.reserve_time?.date)}
                        </p>
                    </>
                }

                <p style={styles.titr}>زمان</p>
                <p style={styles.txtValue}>
                    {item.reserve_time?.start
                        ? <>
                            {item.reserve_time?.start}
                            <span className="mx-1">تا </span>
                            {item.reserve_time?.end}
                        </>
                        : "-"
                    }
                </p>
                {showRefund &&
                    (item.status != "canceled" &&
                        <button className="btn btn-primary w-100 mt-3 px-1 py-1"
                            onClick={() => {
                                if (uType == "manager") {
                                    setModal({
                                        visible: true, oId: item.order_id, rId: item.id,
                                        header: "بلیت منقضی شود ؟", step: "singleEX"
                                    });

                                }
                                else {
                                    setModal({
                                        visible: true, rId: item.id,
                                        header: "بلیت استرداد شود ؟", step: "singleRefund"
                                    });
                                    getRefund();
                                }

                            }}
                            disabled={item.status == "refund"}
                        >
                            {uType == "manager"
                                ? item.status == "refund" ? "استرداد شده" : isAbsent ? "ثبت حضور" : "منقضی کردن "
                                : item.status == "refund" ? "استرداد شده" : "استرداد بلیت"
                            }
                        </button>
                    )
                }
                {item.status == "canceled" &&
                    <p className="bgMain text-white text-center mt-3 py-1 rounded nfs-10">لغو شده</p>
                }
            </div>
        </div>
    )
}

export default DetailPage;


const styles = {
    detailPage: { height: "100%", position: "fixed", left: "0", width: "100%", overflowY: "auto", paddingBottom: "60px" },
    successPage: { background: "#1BA462" },
    errorPage: { background: "#E42A3F" },
    orderItemIcon: {
        width: "29px", height: "29px", background: "#EEEEEE", borderRadius: "4px", marginLeft: "9px",
        display: "flex", alignItems: "center", justifyContent: "center"
    },
    titr: { color: "#767676", fontSize: "10px", fontWeight: "100" },
    txtValue: { fontSize: "10px", fontWeight: "100" },
}

